export const shortAddress = (value?: string | null) => value
  ? `${value.slice(0, 8)}…${value.slice(-6)}`
  : "—";

export const amount = (value?: string | number | null) =>
  Number(value ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });

/**
 * 概览用的紧凑金额。看板上并排放十几个十八位小数会让人读不出量级差异，
 * 这里只保留量级，完整值由调用方放进 title 供核对。
 */
export const compactAmount = (value?: string | number | null) => {
  const numeric = Number(value ?? 0);
  const magnitude = Math.abs(numeric);
  if (magnitude >= 1_000_000) return `${(numeric / 1_000_000).toFixed(2)}M`;
  if (magnitude >= 10_000) return `${(numeric / 1_000).toFixed(1)}K`;
  return numeric.toLocaleString("en-US", { maximumFractionDigits: 2 });
};

/** 覆盖率等比值统一按 ×.xx 展示；无数据时不要伪造成 0。 */
export const ratio = (value?: string | number | null) =>
  value == null || value === "" ? "—" : `${Number(value).toFixed(2)}×`;

export const percentDelta = (current: number, baseline: number) => {
  if (!Number.isFinite(baseline) || baseline === 0) return null;
  return ((current - baseline) / baseline) * 100;
};

export function exportCsv(filename: string, rows: Record<string, unknown>[]) {
  if (!rows.length) return;
  const keys = Object.keys(rows[0]!);
  const escape = (value: unknown) => `"${String(value ?? "").replaceAll('"', '""')}"`;
  const csv = [keys.map(escape).join(","), ...rows.map((row) => keys.map((key) => escape(row[key])).join(","))].join("\n");
  const url = URL.createObjectURL(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
